import Immutable from 'immutable';


const LOAD = 'payValidation/LOAD';
const LOAD_SUCCESS = 'payValidation/LOAD_SUCCESS';
const LOAD_FAIL = 'payValidation/LOAD_REPORT_FAIL';
const LOAD_SUCCESS_ORTHO = 'payValidation/LOAD_SUCCESS_ORTHO';
const SEND_VALIDATION_SUCCESS='payValidation/SEND_VALIDATION_SUCCESS';


const initialState = Immutable.fromJS({
    loading: false,
    payValidationRecords: null,
    payOrthoValidationRecords: null,
});
export default function reducer(state = initialState, action) {
    switch (action.type) {

        case LOAD:
            return state
                .set('loading', true)
                .set('loadErr', null);

        case LOAD_FAIL:
            return state
                .set('loading', false)
                .set('loadErr', action.err)

        case LOAD_SUCCESS:
            return state
                .set('loading', false)
                .set('loadErr', null)
                .set('payValidationRecords', action.res);
        case LOAD_SUCCESS_ORTHO:
                return state
                  .set('loading', false)
                  .set('loadErr', null)
                  .set('payOrthoValidationRecords', action.res);
        case SEND_VALIDATION_SUCCESS:
                return state
                  .set('loading', false)
                  .set('loadErr', null);
        default:
            return state;
    }
}

export const getPayValidationRecords = (props) => async (dispatch, getState, api) => {
    try {
        await api.post('payValidation/getAllRecords', {data:props})
            .then(res =>{
                dispatch({ type: LOAD_SUCCESS, res: res });
            }).catch(err=>{
                dispatch({ type:LOAD_FAIL, err:err})
            })
    } catch (err) {
        dispatch({ type:LOAD_FAIL, err:err})
    }
};

export const getOrthoPayValidation = (props) => async (dispatch, getState, api) => {
    try {
        await api.post('payValidation/getOrthoValidations', {data:props})
            .then(res =>{
                dispatch({ type: LOAD_SUCCESS_ORTHO, res: res });
            }).catch(err=>{
                dispatch({ type:LOAD_FAIL, err:err})
            })
    } catch (err) {
        dispatch({ type:LOAD_FAIL, err:err})
    }
};

export const sendValidationData = (objData) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
        const res = await api.post('payValidation/sendRecords', {data:objData});
        const { data } = res;
        dispatch({type: SEND_VALIDATION_SUCCESS, data});
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
    }
};
